import { Checkbox, FormControlLabel } from '@mui/material';
import { cn } from 'cn';
import { useId } from 'react';

import { unique } from '@vestigas/utils';

import { Hint } from '@vestigas/ui/atoms';
import { ValidationError } from '@vestigas/ui/molecules';

import { useFieldContext } from './form-context';

type P = {
  readonly hint?: string;
  readonly label?: string;
  readonly testId?: string;
} & ComponentStyling;

export const CheckboxField = ({ className, hint, label, style, testId }: P) => {
  const field = useFieldContext();
  const hintId = useId();

  const hasErrors = Boolean(field.state.meta.errors?.length);

  return (
    <div
      className={cn('relative', className)}
      data-testid={testId}
      style={style}
    >
      <FormControlLabel
        className="text-tiga-text-default [&>span]:text-sm [&>span]:select-none"
        control={
          <Checkbox
            checked={Boolean(field.state.value)}
            slotProps={{
              input: {
                'aria-describedby': hint ? hintId : undefined,
              },
            }}
            onChange={(event) => {
              field.handleChange(event.target.checked);
            }}
          />
        }
        label={label}
      />
      {hint ? (
        <Hint className="-mt-2 block pl-8" id={hintId}>
          {hint}
        </Hint>
      ) : null}
      {hasErrors ? (
        <ValidationError>
          {unique(field.state.meta.errors.map(({ message }) => message)).join(
            ', ',
          )}
        </ValidationError>
      ) : null}
    </div>
  );
};
